import { z } from "zod";

export const createDemandSchema = z.object({
  to: z.array(z.string()),
  quantity: z.string(),
});

export type CreateDemandSchema = z.infer<typeof createDemandSchema>;
